import React from 'react';
import Dispatcher from '../dispatchers/Dispatcher';
import Timer from '../lib/Timer';

export default class GameClock extends React.Component {
    componentDidMount() {
        Timer.setDebugFunctions();
    }

    bumpTime(isIncrementing) {
        Dispatcher.dispatch({
            type: 'bump-time',
            data: {
                increment: isIncrementing,
                amount: this.props.time.minuteBump ? 60 : 2,
                eventCount: this.props.eventCount,
                time: this.props.time,
                toiClockNotStarted: this.props.toiClockNotStarted
            }
        });
    }

    renderBumpAmount() {
        if (this.props.time.minuteBump) {
            return '1m';
        } else {
            return '2s';
        }
    }

    handleVideoStampClick() {
        Dispatcher.dispatch({
            // in the TOI tagger this button is repurposed as a "Flag" button that marks
            // the currently active shifts as needing post-game review.
            type: this.props.flagMode ? 'toi-flag' : 'video-stamp',
            data: {
                time: this.props.time
            }
        });
    }

    handleStopInPlayClick() {
        Dispatcher.dispatch({
            type: 'toggle-stop-in-play'
        });
    }

    renderClockButtons() {
        const stampLabel = this.props.flagMode ? 'Flag' : 'Video Stamp';
        const stampClass = `btn video-stamp${this.props.flagMode ? ' flag' : ''}`;

        if (this.props.clockRunning) {
            return (
                <div className="clock-btn-row">
                    <div className={stampClass} onClick={() => this.handleVideoStampClick()}>
                        <span>{stampLabel}</span>
                    </div>
                    <div
                        className={`btn video-stamp stop-in-play${this.props.stopInPlay ? ' stop-in-play-active' : ''}`}
                        onClick={() => this.handleStopInPlayClick()}>
                        <span>{this.props.stopInPlay ? 'Resume Clock' : 'Stop In Play'}</span>
                    </div>
                </div>
            );
        }

        return (
            <div className={stampClass} onClick={() => this.handleVideoStampClick()}>
                <span>{stampLabel}</span>
            </div>
        );
    }

    render() {
        return (
            <div className="time">
                <div className="inner-container">
                    <div
                        onClick={() => this.bumpTime(false)}
                        className="adj-time minus">
                        <div>{`-${this.renderBumpAmount()}`}</div>
                    </div>
                    <div
                        onClick={() => this.bumpTime(true)}
                        className="adj-time plus">
                        <div>{`+${this.renderBumpAmount()}`}</div>
                    </div>
                    <div className="current-time">
                        {`${this.props.time.minutes}:${this.props.time.seconds}`}
                        <br/>
                        <span>Period {this.props.time.period}</span>
                    </div>
                </div>
                {this.renderClockButtons()}
            </div>
        );
    }
}
